package org.example.project.enginetabular

const val META_COUNT = 6
val META_HEADERS = listOf(
    "Erstellt von", "Erstellt am", "Erstellt um",
    "Ge\u00E4ndert von", "Ge\u00E4ndert am", "Ge\u00E4ndert um"
)


fun currentDateDE(): String {
    val date = js("new Date()")
    val day = date.getDate().toString().padStart(2, '0')
    val month = (date.getMonth() + 1).toString().padStart(2, '0')
    val year = date.getFullYear().toString()
    return "$day.$month.$year"
}

fun currentTimeDE(): String {
    val date = js("new Date()")
    val hours = date.getHours().toString().padStart(2, '0')
    val minutes = date.getMinutes().toString().padStart(2, '0')
    return "$hours:$minutes"
}
